import { useState, useEffect, useRef } from 'react';
import { Col, FormGroup, Input, Label } from 'reactstrap';
import { getRequest } from '../../utils/apiCall';
import { Toast } from 'primereact/toast';

const REGIONS_URL = 'api/v1/regions/';

export default function Regions(props) {
  const toast = useRef(null);

  const [regions, setRegions] = useState({ countries: '', states: '', cities: '' });
  const [selected, setSelected] = useState({ country_id: props.countryId || "", state_id: props.stateId || "", city_id: props.cityId || "" });
  const [isLoading, setIsLoading] = useState(false);

    const showSuccess = (message) => {
        toast.current.show({severity:'success', summary: 'Success', detail: message, life: 3000});
    }
    const showError = (message) => {
        toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
    }

  const handleSelected = async (level, id) => {
    setIsLoading(true);

    try {
        const response = await getRequest(`${REGIONS_URL}${id}`);
        setRegions((prev) => ({ ...prev, [level]: response.data.data }));
        setIsLoading(false);
    } catch (error) {
        if (error?.response?.status === 400 || error?.response?.status === 401 || error?.response?.status === 422 || error?.response?.status === 429 || error?.response?.status === 500) {
            showError(error?.response?.data?.message);
          } 
          setIsLoading(false);
    } finally {
        setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const level = e.target.name;
    const id = e.target[e.target.selectedIndex].value;

    setSelected(() => ({ ...selected, [level]: id }));
    props.handleSelectRegions({ ...selected, [level]: id });
  };

  useEffect(() => {
    handleSelected('countries', 0);
  }, []);

  useEffect(() => {
    if (selected.country_id > 0) {
        handleSelected('states', selected.country_id);
    }
  }, [selected.country_id]);

  useEffect(() => {
    if (selected.state_id > 0) {
        handleSelected('cities', selected.state_id);
    }
  }, [selected.state_id]);

  return (
        <>
            <Toast ref={toast} position="top-center" />

            <Col md={props.col}>
                <FormGroup floating>
                    <Input 
                        type='select'
                        name='country_id'
                        value={selected.country_id}
                        placeholder='Choose Country'
                        onChange={handleChange}>
                        <option value="" >
                            Choose Country
                        </option>
                        {
                            regions.countries &&
                                regions.countries.map((country) => (
                                    <option  id={country.id} key={country.id} value={country.id}>
                                        {country.title}
                                    </option>
                                ))
                        }
                    </Input>
                    <Label>Country</Label>
                </FormGroup>
            </Col>
            <Col md={props.col}>
                <FormGroup floating>
                    <Input 
                        value={selected.state_id}
                        type='select' 
                        name='state_id' 
                        placeholder='Choose State' 
                        onChange={handleChange}>
                    <option value="" >
                            Choose State
                        </option>
                        {
                            regions.states && 
                                regions.states.map((state) => (
                                <option id={state.id} key={state.id} value={state.id}>
                                    {state.title}
                                </option>
                            ))}
                    </Input>
                    <Label>State</Label>
                </FormGroup>
            </Col>
            <Col md={props.col}>
                <FormGroup floating>
                    <Input 
                        value={selected.city_id}
                        type='select' 
                        name='city_id' 
                        placeholder='Choose City' 
                        onChange={handleChange}>
                        <option value="" >
                            Choose City
                        </option>
                        {
                            regions.cities &&
                                regions.cities.map((city) => (
                                <option id={city.id} key={city.id} value={city.id}>
                                    {city.title}
                                </option>
                            ))
                        }
                    </Input>
                    <Label>City</Label>
                </FormGroup>
            </Col>
        </>
                   
  );
}
